<template>
  <v-touch class="photo_swipe" v-on:swipeleft="onSwipeLeft" 
    v-on:swiperight="onSwipeRight" 
    v-on:panend="panend"
    v-on:pinchend="pinchend($event)">

    <div class="photo" v-for="(photo, index) in photos" :key="photo.id" v-if="currentIndex === index">
      <div class="user_profile">
        <div class="user_avatar" :style="{'background-image': 'url(' + photo.uploader.avatarCdnUrl + ')'}" v-if="photo.uploader.avatarCdnUrl"></div>
        <div class="user_avatar" style="background-image: url(../assets/avatar.png)" v-if="!photo.uploader.avatarCdnUrl"></div>
        <div class="user_name">{{photo.uploader.fullName}}</div>
        <div class="btn_like" @click="likePhoto(photo.groupId, photo.albumId, photo.id)"></div>
        <div class="load_original_box">
          <div class="btn_load_original_photo" @click="loadOriginalPhoto(index)" v-if="!showOriginalPhotos[index]">加载原图</div>
          <div class="btn_load_original_photo" v-if="showOriginalPhotos[index]">原图 (请长按保存)</div>
        </div>
        <div class="swiper-button-prev" v-if="!isMobile" @click="loadPrevious"></div>
        <div class="swiper-button-next" v-if="!isMobile" @click="loadNext"></div>
      </div>
      <img :style="imgStyle" :src="photo.cdnUrl1600" v-if="!showOriginalPhotos[index]" @click="exitBigPhoto" alt="">
      <img :style="imgStyle" :src="photo.cdnUrl" v-if="showOriginalPhotos[index]" @click="exitBigPhoto" alt="">
    </div>

    <div class="pagination">{{currentIndex + 1}} <span>/ {{this.photos.length}}</span></div>
    <div class="exit_big_mode" @click="exitBigPhoto">✕</div>
  </v-touch>
</template>

<script>

export default {
  name: 'FaPhotoGallery',
  props: ['photos', 'index'],
  data: function () {
    return {
      currentIndex: 0,
      imgStyle: {},
      scale: 1,
      showOriginalPhotos: [],
      isMobile: true
    }
  },
  async created () {
    try {
      this.currentIndex = this.index
      this.isMobile = this.$faUtil.browser.isMobile
    } catch (err) {
      this.$faLogger.error('FaPhotoGallery.vue:created', err)
    }
  },
  methods: {
    loadPrevious() {
      if (this.currentIndex > 0 && this.scale === 1) {
        this.currentIndex -= 1
      }
    },
    loadNext() {
      if (this.currentIndex < this.photos.length - 1 && this.scale === 1) {
        this.currentIndex += 1
      }
    },
    onSwipeLeft() {
      this.loadNext()
    },
    onSwipeRight() {
      this.loadPrevious()
    },
    pinchend(e) {
      let scale = e.scale < 1 ? 1 : e.scale
      this.scale = scale
      this.imgStyle = {
        transform: `scale(${scale})`
      }
    },
    panend(e) {
      if (this.scale > 1) {
        this.imgStyle = {
          transform: `scale(${this.scale})`,
          marginLeft: e.deltaX + 'px',
          marginTop: e.deltaY + 'px'
        }
      }
    },
    loadOriginalPhoto(index) {
      this.$set(this.showOriginalPhotos, index, true)
    },
    exitBigPhoto(index) {
      this.$emit('close')
    },
    async likePhoto(groupId, albumId, photoId) {
      try {
        await this.$faApi.likePhoto({
          groupId,
          albumId,
          photoId
        })
      } catch (err) {
        this.$faLogger.error('FaPhotoGallery.vue:likePhoto', err)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .photo_swipe {
    position: fixed;
    top: -100px;
    bottom: -100px;
    left: 0;
    right: 0;
    background-color: hsla(0,0%,0%,1);
    z-index: 999;
    .photo {
      width: 100%;
      height: 100%;
      display: flex;
      background-color: #000;
      align-items: center;
      img {
        width: 100%;
      }
      .swiper-button-prev {
        position: fixed;
        top: 50%;
        background-image: url('../assets/btn_prev.svg');
        
      }
      .swiper-button-next {
        position: fixed;
        top: 50%;
        background-image: url('../assets/btn_next.svg');
      }
    }
    .user_profile {
      position: absolute;
      z-index: 19990;
      width: 100%;
      height: 48px;
      bottom: 100px;
      .user_avatar {
        position: fixed;
        left: 0;
        margin: 8px;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-size: 32px 32px;
      }
      .user_name {
        position: absolute;
        left: 48px;
        margin: 8px 0;
        height: 32px;
        line-height: 32px;
        font-size: 15px;
        font-weight: 500;
        color: hsla(0,0%,100%,0.5);
      }
      .btn_like {
        position: absolute;
        right: 0;
        margin: 8px;
        width: 32px;
        height: 32px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url('../assets/btn_like.png');
      }

      .btn_already_like {
        position: absolute;
        right: 0;
        margin: 8px;
        width: 32px;
        height: 32px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url('../assets/btn_me_red.png');
      }
    }
    .pagination {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 48px;
      line-height: 48px;
      text-align: center;
      font-size: 19px;
      font-weight: 800;
      color: hsla(0,0%,100%,0.5);
      span {
        font-weight: 100;
      }
    }
    .load_original_box {
      position: absolute;
      z-index: 2000;
      bottom: 48px;
      width: 100%;
      height: 48px;
    }
    .btn_load_original_photo {
      position: relative;
      margin: 8px auto;
      width: 160px;
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      text-align: center;
      color: rgba(255, 255, 255, 0.5);
      border-radius: 16px;
      border: 1px solid hsla(0,0%,100%,0.2);
      cursor: pointer;
    }
  }
  .exit_big_mode {
    position: fixed;
    margin: 0;
    padding: 0;
    top: 0;
    left: 0;
    width: 48px;
    height: 48px;
    line-height: 48px;
    font-size: 24px;
    text-align: center;
    color: hsla(0,0%,100%,0.5);
    z-index: 2000;
    cursor: pointer;
  }
</style>
  